/* ===========================================================================
   Comportamento COMPARTILHADO das landing pages da CalmWave.

   Usado por toda section que siga o contrato de IDs abaixo. Hoje:
   `lp-rest` (aridez espiritual) e `lp-vibration` (prosperidade).

   CONTRATO — a section precisa entregar estes IDs, ou a parte correspondente
   simplesmente nao liga (o arquivo inteiro e defensivo, nada estoura):

     #lpr-price  com data-unit, data-compare, data-currency, data-max
     #lpr-buy    <form> para /cart/add, com #lpr-qty dentro
     #lpr-qm #lpr-qv #lpr-qp #lpr-total #lpr-was #lpr-save #lpr-atc #lpr-qtynote
     #lpr-gal + #lpr-thumbs .thumb   (galeria)
     #lpr-more + .rev.is-more        (mais depoimentos)
     #lpr-lb #lpr-lbi #lpr-lbx       (lightbox)
     .acc-h + aria-controls          (acordeao)

   Quatro coisas, nenhuma essencial para vender: acordeao, quantidade, galeria e
   lightbox. O ADD TO CART e um <form> POST de verdade — se este arquivo nao
   carregar, a pagina continua vendendo, so que com quantidade 1 e sem galeria.

   NAO ha tabela de preco aqui. O preco unitario sai do Liquid via data-attr,
   que sai da variante na loja. Duplicar valor em JS foi como LP e loja
   divergiram em outros projetos.
   =========================================================================== */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- acordeao */
  var heads = document.querySelectorAll('.acc-h');
  for (var i = 0; i < heads.length; i++) {
    heads[i].addEventListener('click', function () {
      var open = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!open));
      var panel = document.getElementById(this.getAttribute('aria-controls'));
      if (panel) panel.classList.toggle('open', !open);
    });
  }

  /* ------------------------------------------------- quantidade e preco */
  var price = document.getElementById('lpr-price');
  var form  = document.getElementById('lpr-buy');

  if (price && form) {
    /* Centavos, como a Shopify entrega. Dividir so na hora de exibir. */
    var UNIT    = parseInt(price.getAttribute('data-unit'), 10) || 0;
    var COMPARE = parseInt(price.getAttribute('data-compare'), 10) || 0;
    var CUR     = price.getAttribute('data-currency') || 'USD';
    var MAXQ    = parseInt(price.getAttribute('data-max'), 10) || 5;

    /* Intl em vez do money_format da loja: o filtro `money` roda no servidor e
       nao existe aqui. Para uma loja em USD os dois produzem "$79.99". Se um dia
       a loja vender em outra moeda, o iso_code ja vem do carrinho pelo Liquid. */
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: CUR
      });
    } catch (e) {
      fmt = { format: function (v) { return '$' + v.toFixed(2); } };
    }
    function money(cents) { return fmt.format(cents / 100); }

    var qv      = document.getElementById('lpr-qv');
    var qminus  = document.getElementById('lpr-qm');
    var qplus   = document.getElementById('lpr-qp');
    var input   = document.getElementById('lpr-qty');
    var total   = document.getElementById('lpr-total');
    var was     = document.getElementById('lpr-was');
    var save    = document.getElementById('lpr-save');
    var note    = document.getElementById('lpr-qtynote');
    var atc     = document.getElementById('lpr-atc');
    var n = 1;

    function render() {
      if (qv)    qv.textContent = String(n);
      if (input) input.value = String(n);
      if (total) total.textContent = money(UNIT * n);

      /* compare_at_price e opcional na Shopify. Sem ele nao existe "de/por" —
         escondemos os dois elementos em vez de inventar um preco de ancora. */
      if (COMPARE > UNIT) {
        if (was)  { was.textContent = money(COMPARE * n); was.hidden = false; }
        if (save) { save.textContent = 'SAVE ' + money((COMPARE - UNIT) * n); save.hidden = false; }
      } else {
        if (was)  was.hidden = true;
        if (save) save.hidden = true;
      }

      if (atc) atc.textContent = n > 1 ? 'ADD ' + n + ' TO CART' : 'ADD TO CART';
      if (note) note.textContent = n === MAXQ ? 'Maximum ' + MAXQ + ' per order'
                                              : 'Maximum ' + MAXQ + ' per order';

      if (qminus) { qminus.disabled = n <= 1;    qminus.style.opacity = n <= 1 ? '.35' : '1'; }
      if (qplus)  { qplus.disabled  = n >= MAXQ; qplus.style.opacity  = n >= MAXQ ? '.35' : '1'; }
    }

    function setQ(v) { n = Math.max(1, Math.min(MAXQ, v)); render(); }
    if (qminus) qminus.addEventListener('click', function () { setQ(n - 1); });
    if (qplus)  qplus.addEventListener('click',  function () { setQ(n + 1); });
    render();
  }

  /* ----------------------------------------------------------- galeria */
  var main = document.getElementById('lpr-gal');
  var thumbs = document.querySelectorAll('#lpr-thumbs .thumb');
  for (var t = 0; t < thumbs.length; t++) {
    thumbs[t].addEventListener('click', function () {
      var img = this.querySelector('img');
      if (!img || !main) return;
      /* `srcset` da miniatura pede a versao pequena. Trocar so o src deixaria o
         navegador escolher a miniatura de 200px para o quadro de 560px. */
      main.removeAttribute('srcset');
      main.src = img.getAttribute('data-full') || img.src;
      main.alt = img.alt;
      for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('on');
      this.classList.add('on');
    });
  }

  /* ---------------------------------------------------- mais depoimentos */
  var more = document.getElementById('lpr-more');
  if (more) {
    more.addEventListener('click', function () {
      var hidden = document.querySelectorAll('.rev.is-more');
      for (var r = 0; r < hidden.length; r++) hidden[r].classList.add('on');
      more.remove();
    });
  }

  /* -------------------------------------------------------------- lightbox */
  var lb  = document.getElementById('lpr-lb');
  var lbi = document.getElementById('lpr-lbi');
  if (!lb || !lbi) return;

  function open(img) {
    lbi.src = img.getAttribute('data-full') || img.currentSrc || img.src;
    lbi.alt = img.alt || '';
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function close() {
    lb.hidden = true;
    lbi.src = '';
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var z = e.target.closest ? e.target.closest('.zoom') : null;
    if (z && z.tagName === 'IMG') { open(z); return; }
    if (e.target.id === 'lpr-lbx' || e.target.id === 'lpr-lb') close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lb.hidden) { close(); return; }
    if ((e.key === 'Enter' || e.key === ' ') &&
        e.target.classList && e.target.classList.contains('zoom')) {
      e.preventDefault();
      open(e.target);
    }
  });
})();
